/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
const ALL = ['agent-definitions'] as const;

export const AGENT_BUILDER_QUERY_KEYS = {
  all: ALL,
  list: () => [...ALL, 'list'] as const,
  detail: (id: string) => [...ALL, 'detail', id] as const,
  versions: (id: string) => [...ALL, 'versions', id] as const,
  version: (id: string, version: number) => [...ALL, 'versions', id, version] as const,
  audit: (id: string) => [...ALL, 'audit', id] as const,
  files: (id: string) => [...ALL, 'files', id] as const,
  pendingWidgets: (id: string) => [...ALL, 'pending-widgets', id] as const,
  modelCatalog: () => [...ALL, 'model-catalog'] as const,
  summaries: (contextId: string) => ['conversation-summaries', contextId] as const,
  dataEntries: (contextId: string) => ['conversation-data', contextId] as const,
  dataEntry: (contextId: string, key: string) => ['conversation-data', contextId, key] as const,
};
